import { render, staticRenderFns } from "./echarts1.vue?vue&type=template&id=2b2c54e6&"
import script from "./echarts1.vue?vue&type=script&lang=js&"
export * from "./echarts1.vue?vue&type=script&lang=js&"
import style0 from "./echarts1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports